import { Text, Stack, Flex, Box } from '@mantine/core';
import { IconDisc, IconInfoCircle } from '@tabler/icons';
import { useTranslation } from 'react-i18next';
import { FC, useEffect, useState } from 'react';
import { GB, formatAmount } from '../../utils';
import { useStyles } from './styles';
import { Modal } from '@components/modal';

interface isExpiredPaymentProps {
  usedSpace?: number;
}

export const ExpiredPayment: FC<isExpiredPaymentProps> = ({ usedSpace }) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [usedAmmount, setUsedAmmount] = useState<string>('');

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const getUsedSpace = (amount: number) => {
    const currentAmount = amount / GB;
    return formatAmount(currentAmount);
  };

  useEffect(() => {
    if (!usedSpace) {
      setUsedAmmount('0');
    }
    if (usedSpace) {
      setUsedAmmount(getUsedSpace(usedSpace));
    }
  }, [usedSpace]);

  return (
    <Box className={classes.boxContainer}>
      <Stack gap="8px">
        <Flex direction="column" gap="8px" py="8px">
          <Text fz="sm" fw="500" sx={{ textAlign: 'center' }}>
            {t('filials.diskSpace.expiredPayment')}
          </Text>
          <Text sx={{ textAlign: 'center' }} fz="xs" c="#848E98">
            {t('filials.diskSpace.warning')}
          </Text>
        </Flex>
        <Flex justify="space-between" align="center">
          <Box className={classes.spaceBox}>
            <IconDisc size={20} color="#FF6B6B" />
            <Text ml="2px" c="#FF6B6B" fz="xs">
              {t('filials.diskSpace.usedSpace')} {usedAmmount}
            </Text>
          </Box>
          <Box className={classes.infoBox} onClick={() => setOpenModal(true)}>
            <IconInfoCircle size={14} color="#FF6B6B" />
          </Box>
        </Flex>
      </Stack>
      <Modal
        size="lg"
        title="Если срок действия подписки истек"
        opened={openModal}
        onClose={handleCloseModal}
      >
        <Box className={classes.modalRoot}>
          <Box className={classes.modalContainer}>
            <Stack gap="4px" className={classes.infoGroup}>
              <Text fz="14px">{t('filials.expiredInfo1')}</Text>
              <Text fz="14px">{t('filials.expiredInfo2')}</Text>
              <Text fz="14px">{t('filials.expiredInfo3')}</Text>
              <Text fz="14px">{t('filials.expiredInfo4')}</Text>
            </Stack>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};
